import React, { useState, useEffect } from "react";
import servisorIcon from "../../../assets/servisorWhiteLogo.png";
import CheckBox from "../../../assets/icons/checkBox.svg";
import vehicleTag from "../../../assets/tags/serviceSelection.svg";
import dataAnimation from "../../../assets/lottie/Servisor_03_Service Plan.json";
import NextIcon from "../../../assets/icons/ChevronRightFilled.svg";

import {
  Typography,
  Box,
  Container,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  BottomNavigation,
  Paper,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { ServiceDetailsModel } from "../../../models/ServiceDetailsModel";
import { VehicleDetailsModel } from "../../../models/VehicleDetailsModel";
import { useGlobalContext } from "../../../services/context/globalContext";
import { HeaderText } from "../../../components/common/HeaderText";
import { CustomHeaderText } from "../../../components/common/CustomHeader";
import ProgressBar from "../../../components/common/ProgressBar";
import { PageLayout } from "../../../components/layout/PageLayout";

const SERVICE_A_LABELS = [
  "ENGINE OIL",
  "OIL FILTER",
  "SUMP PLUG",
  "SUMP PLUG WASHER",
];
const SERVICE_B_LABELS = ["FEED UNIT", "FUEL PUMP"];

export const MercedesComponent: React.FC<any> = () => {
  const { registrationNumber, milleage } = useGlobalContext();
  const [selectedServicePlan, setSelectedServicePlan] = useState("");

  const [vehicleDetails, setVehicleDetails]: any = useState(
    new VehicleDetailsModel({}),
  );
  const [serviceDetails, setServiceDetails] = useState(
    new ServiceDetailsModel({}),
  );
  const history = useHistory();

  const fetchVehicleDetails = (): void => {
    const vehicleData = JSON.parse(
      localStorage.getItem("vehicle-details") ?? "",
    );
    if (vehicleData && vehicleData.vehicle_make) {
      setVehicleDetails(vehicleData);
    }
  };

  useEffect(() => {
    fetchVehicleDetails();
  }, []);

  const getPlanObject = (plan: any) => {
    if (plan === "false") {
      return {
        plan: "false",
        label: "Service A",
        labour_time: 1,
        labels: SERVICE_A_LABELS,
      };
    } else if (plan === "true") {
      return {
        plan: "true",
        label: "Service B",
        labour_time: 2,
        labels: SERVICE_B_LABELS,
      };
    } else {
      return {};
    }
  };

  const assignVehicle = (ev: any, target: string) => {
    if (target === "registration_number") {
      setServiceDetails((prev: any) => ({
        ...prev,
        registration_number: registrationNumber,
      }));
      setVehicleDetails((prev: any) => ({
        ...prev,
        RegistrationNumber: registrationNumber,
      }));
    } else if (target === "milleage") {
      setServiceDetails((prev: any) => ({
        ...prev,
        milleage: milleage,
      }));
      setVehicleDetails((prev: any) => ({
        ...prev,
        milleage: milleage,
      }));
    } else if (target === "service_plan") {
      const plan = ev.target.value;
      const planObj = getPlanObject(plan);
      localStorage.setItem("ServicePlan", JSON.stringify(planObj));
      setServiceDetails((prev: any) => ({
        ...prev,
        service_plan: plan,
        labour_time: planObj.labour_time,
      }));
    }
  };

  const saveVehicle = () => {
    const getService = JSON.parse(
      localStorage.getItem("ServicePlan") ?? "{}",
    ).plan;
    if (getService === "false" || getService === "true") {
      history.push("/onboarding/4");
    }
  };

  return (
    <PageLayout animationData={dataAnimation}>
      <HeaderText headerText="VEHICLE DETAILS" headerImage={servisorIcon} />

      <Box
        sx={{
          backgroundColor: "#FFF",
          overflow: "auto",
          maxHeight: "calc(100vh - 64px)",
          paddingBottom: "100px",
          position: "relative",
          paddingTop: { lg: "52px" },
          display: "flex",
          alignSelf: { xs: "normal", lg: "center" },
          flexDirection: { xs: "column", lg: "column" },
        }}
      >
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            alignSelf: "center",
            width: { xs: "100%", lg: "70%" },
          }}
        >
          <img src={vehicleTag} alt="/" />
        </Box>

        <CustomHeaderText headerText="Select the service type (A or B) displayed on your dashboard" />

        <Container
          disableGutters
          sx={{
            width: { xs: "90%", lg: "70%" },
            marginTop: { xs: "-10px", lg: "0" },
            borderRadius: { xs: "4px", lg: "4px" },
            backgroundColor: "#FFF",
            paddingX: { xs: "20px", lg: "0" },
          }}
        >
          <Box>
            <Box
              sx={{
                display: { xs: "flex", lg: "none" },
                alignSelf: "left",
                width: { xs: "100%", lg: "70%" },
                paddingTop: { xs: "20px", lg: "0" },
              }}
            >
              <img src={vehicleTag} alt="/" />
            </Box>
            <form>
              <Box sx={{ display: "flex", width: "100%" }}>
                <RadioGroup
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  value={selectedServicePlan}
                  onChange={(ev) => {
                    setSelectedServicePlan(ev.target.value);
                    assignVehicle(ev, "service_plan");
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      py: "10px",
                      width: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          value="false"
                          name="false"
                          icon={
                            <Box
                              sx={{
                                border: "1px solid var(--gray-300, #D0D5DD)",
                                width: "20px",
                                height: "20px",
                                borderRadius: "10px",
                              }}
                            ></Box>
                          }
                          checkedIcon={
                            <img
                              src={CheckBox}
                              alt="tick"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                          }
                        />
                      }
                      label={
                        <Box
                          sx={{
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                            }}
                          >
                            Service A
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 14,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              ml: 1,
                              maxWidth: {
                                xs: "150px",
                                sm: "260px",
                                md: "340px",
                              },
                            }}
                          >
                            - Oil service with diagnostics
                          </Typography>
                        </Box>
                      }
                      sx={{
                        margin: "0px",
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "space-between",
                        borderRadius: "8px",
                        padding: "16px",
                        color: "var(--text-primary, rgba(0, 0, 0, 0.87))",

                        border:
                          serviceDetails.service_plan === "false"
                            ? "1px solid #004FFA"
                            : "1px solid var(--gray-200, #EAECF0)",
                        backgroundColor:
                          serviceDetails.service_plan === "false"
                            ? "#E9F0FF"
                            : "",
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          value="true"
                          name="true"
                          icon={
                            <Box
                              sx={{
                                border: "1px solid var(--gray-300, #D0D5DD)",
                                width: "20px",
                                height: "20px",
                                borderRadius: "10px",
                              }}
                            ></Box>
                          }
                          checkedIcon={
                            <img
                              src={CheckBox}
                              alt="tick"
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                          }
                        />
                      }
                      label={
                        <Box
                          sx={{
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                            }}
                          >
                            Service B
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 14,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              ml: 1,
                              maxWidth: {
                                xs: "150px",
                                sm: "260px",
                                md: "340px",
                              },
                            }}
                          >
                            - Oil service + additional components
                          </Typography>
                        </Box>
                      }
                      sx={{
                        margin: "0px",
                        display: "flex",
                        flexDirection: "row-reverse",
                        justifyContent: "space-between",
                        flexGrow: "2",
                        borderRadius: "8px",
                        padding: "16px",
                        border:
                          serviceDetails.service_plan === "true"
                            ? "1px solid #004FFA"
                            : "1px solid var(--gray-200, #EAECF0)",
                        backgroundColor:
                          serviceDetails.service_plan === "true"
                            ? "#E9F0FF"
                            : "",
                        color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
                      }}
                    />
                  </Box>
                </RadioGroup>
              </Box>

              <Box sx={{ mt: 4, mb: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 18,
                    color: "#333",
                    mb: 0.5,
                  }}
                >
                  Not sure which service you need?
                </Typography>

                <Typography sx={{ color: "#333", fontSize: 14 }}>
                  Check your dashboard for 'A', 'B', 'Service A', or 'Service B'
                  and select the matching option above.
                </Typography>
              </Box>

              <Paper
                sx={{
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  paddingY: "10px",
                  zIndex: "999",
                  width: { xs: "100%", lg: "50%" },
                  borderRadius: "0",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                elevation={0}
              >
                <BottomNavigation
                  sx={{
                    width: { xs: "100%", lg: "70%" },

                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Box
                    py={3}
                    sx={{
                      display: { xs: "flex" },
                      flexDirection: "row",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box>
                      <Button
                        onClick={() => history.push("/onboarding/2")}
                        sx={{
                          padding: "0",
                          margin: "0",
                          display: "flex",
                          borderRadius: "0",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={NextIcon}
                            alt="/"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              transform: "rotate(180deg)",
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: "700",
                            color: "#101828",
                          }}
                        >
                          Back
                        </Typography>{" "}
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ProgressBar value={75} />
                    </Box>
                    <Box>
                      <Button
                        disabled={!selectedServicePlan}
                        onClick={() => saveVehicle()}
                        sx={{
                          padding: "0",
                          margin: "0",
                          display: "flex",
                          borderRadius: "0",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: "700",

                            color: !selectedServicePlan ? "grey" : "#101828",
                          }}
                        >
                          Next
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={NextIcon}
                            alt="/"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          />
                        </Box>
                      </Button>
                    </Box>
                  </Box>
                </BottomNavigation>
              </Paper>
            </form>
          </Box>
        </Container>
      </Box>
    </PageLayout>
  );
};
